import { get, post } from "@/services/axiosUitils";

const basePath = "/city_collab/feeds";

export interface FeedResponse {
  id: string;
  author: string;
  author_full_name?: string;
  author_first_name?: string;
  author_last_name?: string;
  title: string;
  organization_id?: string;
  department_id?: string;
  position_id?: string;
  visibility?: number;
  visibility_label?: string;
  content?: string;
  attachments?: string | string[] | null;
  feed_type?: number;
  feed_type_name?: string;
  reference_id?: string;
  like_count?: number;
  dislike_count?: number;
  comments_count?: number;
  organization_logo?: string | null;
  organization_banner_image?: string | null;
  created_on?: string;
  comments?: any[];
  provenance?: string;
  scope?: string;
  thread_days_remaining?: number;
  thread_closed?: boolean;
  city?: string;
  audience?: string;
  acknowledged_count?: number;
  role?: string;
  department?: string;
  user_has_liked?: boolean;
}

export interface FeedCommentResponse {
  id?: string;
  feed?: string;
  user: string;
  comment: string;
  created_on: string;
  user_full_name?: string;
  user_profile_photo?: string | null;
}

class FeedService {
  getFeeds = async (params?: Record<string, any>): Promise<FeedResponse[]> => {
    try {
      const response = await get<any>(`${basePath}/`, {
        notifyMessage: false,
        params,
      });

      if (!response) {
        return [];
      }

      if (Array.isArray(response)) {
        return response;
      }

      if (Array.isArray(response.results)) {
        return response.results;
      }

      if (Array.isArray(response.data)) {
        return response.data;
      }

      return [];
    } catch (error) {
      console.error("Error fetching feeds:", error);
      return [];
    }
  };

  createFeedComment = async (payload: {
    feed: string;
    comment: string;
  }): Promise<FeedCommentResponse | null> => {
    try {
      const response = await post<FeedCommentResponse>(
        `/city_collab/feed-comments/`,
        payload,
        {
          notifyMessage: true,
        }
      );

      return response ?? null;
    } catch (error) {
      console.error("Error creating feed comment:", error);
      return null;
    }
  };

  createFeed = async (payload: any): Promise<FeedResponse | null> => {
    try {
      const response = await post<FeedResponse>(`${basePath}/`, payload, {
        notifyMessage: true,
      });

      return response ?? null;
    } catch (error) {
      console.error("Error creating feed:", error);
      return null;
    }
  };

  createFeedReaction = async (payload: {
    feed: string;
    reaction_type: number;
  }): Promise<any | null> => {
    try {
      const response = await post<any>(
        `/city_collab/feed-reactions/`,
        payload,
        {
          notifyMessage: true,
        }
      );

      return response ?? null;
    } catch (error) {
      console.error("Error creating feed reaction:", error);
      return null;
    }
  };
}

const instance = new FeedService();
export default instance;
